import React from "react";
import DataVisualization from "../components/DataVisualization";
import {Col, Row} from 'reactstrap';
import Card from "../components/Card";

const RetailDashboard = ({dataVisualizations}) => {

    const {
        trafficCount,
        demographics,
        business,
        tradeArea,
        segmentation,
        floatingStats,
        consumerSpending
    } = dataVisualizations;

    const displayColumnIfPresent = (kpiKey, lg = 6, xs = 12) =>
        //TODO: technical debt here refactor in it's own component when we are gonna have new Dashboard
        <>
            {
                kpiKey !== undefined &&
                <Col className="collookup" lg={lg} xs={xs}>
                    <Card title={kpiKey.title}> <DataVisualization data={kpiKey}/> </Card>
                </Col>
            }
        </>;


    return (
        <div className="dashboard">
            <div className="content">
                <Row>
                    {displayColumnIfPresent(tradeArea)}
                    {displayColumnIfPresent(consumerSpending)}
                    {displayColumnIfPresent(floatingStats)}
                    {displayColumnIfPresent(demographics)}
                    {displayColumnIfPresent(segmentation)}
                    {displayColumnIfPresent(business)}
                    {displayColumnIfPresent(trafficCount, 12, 12, 12, 12)}
                </Row>
            </div>
        </div>
    )
};
export default RetailDashboard;